export const LinkAccountsModal = {
  LinkAccountsModal: 'link-accounts-modal'
} as const;
